import { ErrorMessage, Formik } from "formik";
import { useEffect, useState } from "react";
import { Col, Form, Input, Label, Row } from "reactstrap";
import CustomButton from "../../../../../Components/CustomElements/FormElements/CustomButton";
import TextError from "../../../../../Components/FormikError/TextError";
import { AddMetaProps, AddStaffProps } from "../../../../../Type";
import {
  AddMetaInitialValues,
  MetaValidationSchema,
} from "./AddMetaMethods/FormikValidation";
import {
  MetaSubmitHandler,
  addModalInitialValuesHandler,
} from "./AddMetaMethods/AddMetaModalMethods";

const AddMeta = ({
  setIsOpen,

  modalEditData,
  refetch,
}: AddMetaProps) => {
  const [addModalInitialValues, setAddModalInitialValues] =
    useState(AddMetaInitialValues);
  const [editMode, setEditMode] = useState<boolean>(false);

  useEffect(() => {
    addModalInitialValuesHandler(
      modalEditData,
      setAddModalInitialValues,
      setEditMode
    );
  }, [modalEditData]);

  return (
    <Formik
      validationSchema={MetaValidationSchema}
      initialValues={addModalInitialValues}
      enableReinitialize
      onSubmit={(values, actions) => {
        MetaSubmitHandler(
          values,
          actions,
          setIsOpen,
          refetch,
          editMode,
          modalEditData?.[0]?.id
        );
      }}
    >
      {({
        handleSubmit,
        handleChange,
        isSubmitting,
        values,
        setFieldValue,
        setFieldError,
        errors,
      }) => {
        return (
          <div className="form-wrap">
            <Form onSubmit={handleSubmit}>
              <Row className="gy-4">
                <Col md={12}>
                  <Label>Title of Website</Label>
                  <Input
                    type="text"
                    onChange={handleChange}
                    name="meta_title"
                    value={values?.meta_title}
                    placeholder="Title of Website"
                  />

                  <ErrorMessage name="title" component={TextError} />
                </Col>
                <Col lg={12}>
                  <Label>Description of meta</Label>
                  <Input
                    type="text"
                    onChange={handleChange}
                    value={values?.meta_body}
                    name="meta_body"
                    placeholder="Description of meta"
                  />
                  <ErrorMessage name="description" component={TextError} />
                </Col>
                <Col lg={12}>
                  <CustomButton
                    isLoading={isSubmitting}
                    label="Submit"
                    color="primary"
                    className="sm submit-btn"
                  />
                </Col>
              </Row>
            </Form>
          </div>
        );
      }}
    </Formik>
  );
};

export default AddMeta;
